import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BRAND } from "@/lib/products";

const LINKS = [
  { label: "Home", href: "#home" },
  { label: "Products", href: "#products" },
  { label: "Why Us", href: "#why-us" },
  { label: "How it Works", href: "#how" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Header({ onQuoteClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 16);
    window.addEventListener("scroll", h);
    return () => window.removeEventListener("scroll", h);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl shadow-sm border-b border-slate-200"
          : "bg-white/60 backdrop-blur-md"
      }`}
    >
      <div className="container mx-auto px-4 md:px-8 max-w-7xl flex items-center justify-between h-16 md:h-20">
        <a href="#home" data-testid="brand-link" className="flex items-center gap-3">
          <img
            src={BRAND.logo}
            alt="Beemamen — All Insurance, One Solution"
            className="h-12 md:h-14 w-auto object-contain rounded-lg"
          />
          <div className="leading-tight hidden sm:block">
            <div className="font-hindi text-[11px] md:text-xs text-slate-500">
              आपके विश्वास का साथी
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="px-4 py-2 rounded-full text-sm font-semibold text-slate-700 hover:bg-slate-100 hover:text-slate-900 transition-all"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          <a
            href={`tel:+91${BRAND.phones[0]}`}
            data-testid="header-call-btn"
            className="hidden md:inline-flex items-center gap-2 text-sm font-bold text-[#1e3a8a] hover:text-[#172554] transition-colors"
          >
            <Phone className="w-4 h-4" /> +91 {BRAND.phones[0]}
          </a>
          <Button
            data-testid="header-quote-btn"
            onClick={onQuoteClick}
            className="bg-[#f5b942] hover:bg-[#d99b28] text-slate-900 font-bold rounded-full px-5 md:px-6 h-10 md:h-11 shadow-md hover:shadow-lg transition-all hover:-translate-y-0.5"
          >
            Get Free Quote
          </Button>
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden p-2 rounded-lg hover:bg-slate-100"
            onClick={() => setOpen(!open)}
            aria-label="menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden border-t border-slate-200 bg-white">
          <div className="px-4 py-3 flex flex-col">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="px-3 py-3 text-slate-700 font-semibold hover:bg-slate-50 rounded-lg"
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:+91${BRAND.phones[0]}`}
              className="px-3 py-3 text-[#1e3a8a] font-bold hover:bg-slate-50 rounded-lg inline-flex items-center gap-2"
            >
              <Phone className="w-4 h-4" /> +91 {BRAND.phones[0]}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
